import Rest from '../Rest'

export default class WorkingTimeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/working_times'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
